import { render, staticRenderFns } from "./addpage.vue?vue&type=template&id=3324401f&scoped=true&"
import script from "./addpage.vue?vue&type=script&lang=js&"
export * from "./addpage.vue?vue&type=script&lang=js&"
import style0 from "./addpage.vue?vue&type=style&index=0&id=3324401f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3324401f",
  null
  
)

export default component.exports